import { useSeoMeta } from '@unhead/react';
import { Activity } from 'lucide-react';
import { Layout } from '@/components/Layout';
import { ActivityFeed } from '@/components/ActivityFeed';

/**
 * The ecosystem activity feed (`/feed`) — a minimal, chronological stream
 * of everything happening across the wiki: new articles, forks, edits, new
 * publications, stars, and highlights. Linked from the footer and mirrored
 * (as a capped preview) in the homepage's Activity tab.
 */
export function FeedPage() {
  useSeoMeta({
    title: 'Activity — Wikistar',
    description:
      'The latest writing, forks, stars, and highlights across the Wikistar ecosystem, straight from your relays.',
  });

  return (
    <Layout>
      <div className="mx-auto max-w-2xl px-4 py-8">
        <div className="mb-2 flex items-center gap-2">
          <Activity className="size-6 text-primary" />
          <h1 className="text-2xl font-bold tracking-tight">Activity</h1>
        </div>
        <p className="mb-6 text-sm text-muted-foreground">
          What the community is doing right now — every new article, fork, publication, star, and
          highlight, as your relays see it.
        </p>

        <ActivityFeed />
      </div>
    </Layout>
  );
}
